/**
 * Enum representing the status of a batch operation
 */
export enum BatchStatusEnum {
  All = 'All',
  Queued = 'Queued',
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
  PartiallyCompleted = 'PartiallyCompleted',
  Cancelled = 'Cancelled',
}
